<style lang="scss" scoped>
// @import 'common/sass/reuse.SCSS';
.handle {
  margin: 25px;
  .addBtn {
    margin-left: 20px;
  }
  .handle-row {
    width: 100%;
  }
  .empty {
    padding: 20px;
  }
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 10px;
  width: 50%;
}
.el-select {
  width: 100%;
}
/deep/ .el-drawer__body {
  overflow-y: auto;
}

.description{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
  }
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <el-row class="handle">
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addBtn">
          <el-button type="primary" class="handle-row" icon="el-icon-circle-plus" @click="openConfigWindow">{{ language.addBtnTxt }}</el-button>
        </el-col>
      </el-row>
      <el-row v-loading="configLoading">
        <el-table :data="confListPaging" border>
          <template v-for="(v, i) in language.accHead">
            <el-table-column :label="v.value" :key="i">
              <template slot-scope="scope">
                <el-input v-if="v.writable" type="textarea" maxlength="255" v-model="scope.row[v.key]"></el-input>
                <span v-else>{{ scope.row[v.key] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column :label="language.lastTableColumnTxt" width="120px">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" circle @click="deleteAnnualInterestConfig(scope.row.group)"></el-button>
              <el-button type="primary" icon="el-icon-edit" circle @click="updateConfig(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row class="handle">
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <div class="empty"></div>
        </el-col>
        <el-col :lg="9" :md="9" :sm="9" :xl="9" :xs="9">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :page-sizes="[5, 10, 25, 50]"
            :pager-count="5"
            :total="total"
            @current-change="handlePageChange"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
    <!-- add config window -->
    <el-dialog :title="language.addDialogTitle" :visible.sync="configWindow" :before-close="(done) => {}" :show-close="false">
      <el-form :model="confForm" :rules="rules" ref="confForm" label-position="top">
        <el-form-item :label="language.addGroupTxt" prop="group">
            <el-input v-model="confForm.group"></el-input>
        </el-form-item>
        <el-form-item :label="language.addInterestTxt" prop="interest">
            <el-input v-model="confForm.interest"></el-input>
        </el-form-item>
        <el-form-item :label="language.addCommentTxt" prop="comment">
            <el-input v-model="confForm.comment"></el-input>
        </el-form-item>
        <el-form-item :label="language.addBalanceZeroTxt" prop="balanceZero">
            <el-switch v-model="confForm.balanceZero" active-value="1" inactive-value="0" :active-text="language.yesTxt" :inactive-text="language.noTxt"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetFilledConfig">{{ language.formCancelTxt }}</el-button>
        <el-button type="primary" @click="addAnnualInterestConfig">{{ language.formConfirmTxt }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
    URL_ADDORUPDATE_INTEREST_CONFIG,
    URL_DELETE_INTEREST_CONFIG,
    URL_GET_INTEREST_CONFIG
} from 'api/api'
const data = () => {
    return {
        confListPaging: [],
        confList: [],
        configLoading: false,
        configWindow: false,
        confForm: {
            group: null,
            interest: null,
            comment: null,
            balanceZero: '1',
        },
        updateGroup: null,
        pageNum: 1,
        pageSize: 5,
        total: 0,
    }
}

const mixins = [
    require('common/mixin/base').base({ language: 'annualInterestBonus' }), 
    require('common/mixin/base').base({ reuse: 'reuse' })
]

const computed = {
    rules() {
        const language = this.language;
        const interestRegexp = new RegExp(/^-?[0-9]+([.]{1}[0-9]+){0,1}$/);
        const groupRegexp = new RegExp(/^(,?[\!\*]?([a-zA-Z0-9]+[\_\\-]?)+\*?,?)+$/);
        const rules = {
            group: [
                this.regexpRule(groupRegexp, language.groupRulesRequired, language.groupRulesInvalid),
            ],
            interest: [
                this.regexpRule(interestRegexp, language.interestlRulesRequired, language.interestRulesInvalid),
            ],
            comment: [
                this.byteRule(language.commentRulesRequired,language.commentRulesInvalid),
            ],
        }
        return rules
    },
}

const created = function () {
    this.getAnnualInterestConfig()
}

const methods = {
    addAnnualInterestConfig() {
        this.$refs['confForm'].validate((valid) => {
            if (valid) {
                const modifyBy = JSON.parse(sessionStorage.getItem('user') || '{}').name
                const addObj = {
                    modifyBy, 
                    ...this.confForm
                }
                const isAdd = this.updateGroup != addObj.group
                const successKey = isAdd ? 'addSuccess' : 'updateSuccess'
                const failedKey = isAdd ? 'addFailed' : 'updateFailed'

                this.$http.post(URL_ADDORUPDATE_INTEREST_CONFIG, addObj).then((res) => {
                    const code = res.data.data
                    if (code === 9000) this.$message({ message: this.language[successKey], type: 'success' })
                    else this.$message({ message: this.language[failedKey], type: 'error' })
                    this.getAnnualInterestConfig()
                    this.resetFilledConfig()
                })
            }
        })
    },
    getAnnualInterestConfig() {
        this.configLoading = true
        this.$http.get(URL_GET_INTEREST_CONFIG).then((res) => {
            const result = res.data.data
            this.confList = result
            this.confList.forEach(conf => {
                conf.balanceZero = this.language.balanceZeroMapping[conf.balance_zero]
            })
            this.total = result.length
            this.slicData()
            this.configLoading = false
        })
    },
    updateConfig(row) {
        const group = row.group
        const updateObj = { group, interest: row.interest, comment: row.comment, balance_zero: row.balance_zero }
        this.configWindow = true
        this.$nextTick(function(){
            Object.assign(this.confForm, updateObj)
            this.updateGroup = group
        })
    },
    deleteAnnualInterestConfig(group) {
        const lg = this.language
        this.$confirm(`${lg.deleteMsgTxt}`, lg.notifyTxt, { confirmButtonText: lg.formConfirmTxt, cancelButtonText: lg.formCancelTxt, type: 'warning' }).then(() => {
            this.$http.delete(URL_DELETE_INTEREST_CONFIG, { params: { group } }).then((res) => {
                const code = res.data.data
                if (code == 9000) {
                    this.$message({ message: lg.delSuccess, type: 'success' })
                    // 第N页删除后页码需要减一
                    const countAfterDelete = this.total - 1
                    if(countAfterDelete % this.pageSize === 0) this.pageNum -= countAfterDelete / this.pageSize
                    this.getAnnualInterestConfig()
                } else {
                    this.$message({ message: lg.delFailed, type: 'info' })
                }
            })
        })
    },
    openConfigWindow() {
        this.configWindow = true
        if(this.$refs['confForm']) this.$refs['confForm'].resetFields()
    },
    resetFilledConfig() {
        this.configWindow = false
        this.updateGroup = null
    },
    handlePageChange(val) {
        this.pageNum = val
        this.slicData()
    },
    handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.confListPaging = this.confList.slice(0, this.pageSize)
    },
    slicData() {
        this.confListPaging = this.confList.slice((this.pageNum - 1) * this.pageSize, this.pageNum * this.pageSize);
    },
    byteRule(requiredMsg, invalidMsg) {
        const byteRule = {
            required: true,
            validator: (rule, value, callback) => {
                if(value) {
                    const length = new TextEncoder().encode(value).length;
                    length <= 23 ? callback() : callback(invalidMsg)
                    return;
                } else callback(requiredMsg)
            }, 
            trigger: 'blur'
        }
        return byteRule;
    },
    numberRule(message) {
        const numberRule = {
            type: 'number',  
            validator: (rule, value, callback) => {
                if(value > 0) callback()
                else callback(message)
            }, 
            trigger: 'blur'
        };
        return numberRule;
    },
    regexpRule(regExp, requiredMsg, invalidMsg) {
        const regexpRule = {
            required: true,
            validator: (rule, value, callback) => {
                if(value) {
                    regExp.test(value) ? callback() : callback(invalidMsg)
                    return;
                } else callback(requiredMsg)
            }, 
            trigger: 'blur'
        };
        return regexpRule;
    }
}

const watch = {
  language() {
    this.confListPaging.forEach(conf => {
        conf.balanceZero = this.language.balanceZeroMapping[conf.balance_zero]
    })
  }
}

export default {
    data,
    mixins,
    computed,
    created,
    methods,
    watch,
}
</script>


// WEBPACK FOOTER //
// src/views/report/annual-interest-bonus.vue